var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  default: () => rfc_default,
  generateRfc: () => generateRfc
});
var import_utils = __toModule(require("./utils"));
const VALIDATOR_REGEX = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
const DICTIONARY = "0123456789ABCDEFGHIJKLMN&OPQRSTUVWXYZ \xD1";
const getDigitExpected = (suma, len, rfcWithOutDigit, index) => {
  for (let i = 0; i < len; i++) {
    suma += DICTIONARY.indexOf(rfcWithOutDigit.charAt(i)) * (index - i);
  }
  const validateString = (11 - suma % 11).toString();
  if (validateString == "11") {
    return "0";
  } else if (validateString == "10") {
    return "A";
  }
  return validateString;
};
const validRfc = (rfc, acceptGeneric = true) => {
  const valid = rfc.match(VALIDATOR_REGEX);
  if (valid) {
    return true;
  } else {
    return false;
  }
  const verifyDigit = valid.pop();
  const rfcWithOutDigit = valid.slice(1).join("");
  const len = rfcWithOutDigit.length;
  const index = len + 1;
  let suma = 0;
  if (len !== 12) {
    suma = 481;
  }
  const digitExpected = getDigitExpected(suma, len, rfcWithOutDigit, index);
  if (verifyDigit !== digitExpected && (!acceptGeneric || rfcWithOutDigit + verifyDigit !== "XAXX010101000")) {
    return false;
  } else if (!acceptGeneric && rfcWithOutDigit + verifyDigit == "XEXX010101000") {
    return false;
  }
  return true;
};
const message = () => {
  return "invalid_rfc";
};
const validate = (input) => {
  const rfc = input.toUpperCase();
  return validRfc(rfc);
};
function generateRfc(name, lastNamePaternal, lastNameMaternal, birthdate) {
  const nameWithOutChanges = name;
  const lastNamePaternalWithOutChanges = lastNamePaternal;
  const lastNameMaternalWithOutChanges = lastNameMaternal;
  name = (0, import_utils.removeNames)(name);
  lastNamePaternal = (0, import_utils.removeWords)(lastNamePaternal);
  lastNameMaternal = (0, import_utils.removeWords)(lastNameMaternal);
  const firstLetterPaternal = lastNamePaternal.substring(0, 1);
  let firstVowelPatternal = "";
  for (let i = 1; i < lastNamePaternal.length; i++) {
    if ((0, import_utils.isVowel)(lastNamePaternal.charAt(i))) {
      firstVowelPatternal = lastNamePaternal.charAt(i);
      break;
    }
  }
  const clave = (0, import_utils.calculateHomoClaveAndDigitalVerify)(`${(0, import_utils.formatTextRFC)(lastNamePaternalWithOutChanges)} ${(0, import_utils.formatTextRFC)(lastNameMaternalWithOutChanges)} ${(0, import_utils.formatTextRFC)(nameWithOutChanges)}`);
  const firstLetterMaternal = lastNameMaternal ? lastNameMaternal.substring(0, 1) : name.substring(0, 2);
  const firtsLetterName = name.substring(0, 1);
  const secondPartRFC = lastNameMaternal ? `${firstLetterMaternal}${firtsLetterName}` : `${firstLetterMaternal}`;
  const dayBirth = birthdate.substring(8, 10);
  const monthBirth = birthdate.substring(3, 5).substring(0, 2);
  const yearBirth = birthdate.substring(0, 2);
  const rfc = `${(0, import_utils.removeInconvenientWords)(`${firstLetterPaternal}${firstVowelPatternal}${secondPartRFC}`)}${dayBirth}${monthBirth}${yearBirth}${clave}`;
  const identify = (0, import_utils.getHomoclave)(rfc);
  return `${rfc}${identify}`;
}
const RFC = {
  validate,
  message,
  generateRfc
};
var rfc_default = RFC;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  generateRfc
});
